<ion-toolbar>
  <div class="navbar-items">
    <app-navbar-item *ngFor="let item of items; trackBy: trackByKey" [item]="item" (triggerAction)="triggerAction.emit($event)"></app-navbar-item>
  </div>
</ion-toolbar>
